module.exports = __webpack_public_path__ + "static/media/vaksinasi.2bd02473.jpg";